import React, { useState } from "react"
import * as sessions from "sessions"
import * as api from "brandguard/api"
import * as bglayouts from "brandguard/components/layouts"
import { CancellablePromise } from "real-cancellable-promise"
import * as httpx from "httpx"

export interface Correction {
	id: string
	status: string
	corrected_event_id?: string
	error_message?: string
}

export interface CorrectionAPI {
	create(eventId: string, ...options: httpx.option[]): CancellablePromise<Correction>
	find(correctionId: string, ...options: httpx.option[]): CancellablePromise<Correction>
	list(eventId: string, ...options: httpx.option[]): CancellablePromise<Correction[]>
}

interface props {
	item: { event?: { id?: string; observation?: number } }
	corrections: CorrectionAPI
	progressLabel: string
	onCorrectionComplete?: (correctedEventId: string) => void
}

function correctable(item: { event?: { observation?: number } }): boolean {
	const o = item.event?.observation
	return o === api.Prediction.REJECTED || o === api.Prediction.INREVIEW || o === api.Prediction.REJECTED_BY_REVIEW
}

export default function GenerateCorrection(props: props): JSX.Element {
	const { item, corrections, onCorrectionComplete } = props
	const bearertoken = sessions.useToken()

	const [creating, setCreating] = useState(false)

	const handleCreate = (): void => {
		if (!item.event?.id || creating) return
		setCreating(true)
		corrections.create(item.event.id, bearertoken).then((correction) => {
			onCorrectionComplete?.(correction.corrected_event_id || "")
		}).catch((cause) => {
			console.error("bgcorrections: create failed", cause)
			setCreating(false)
		})
	}

	if (!correctable(item)) return <></>

	return (
		<bglayouts.CorrectionButton onClick={handleCreate} disabled={creating}>
			{creating ? props.progressLabel + " correction in progress..." : "Generate Correction"}
		</bglayouts.CorrectionButton>
	)
}
